import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFolder } from 'src/app/models/document.models';
import { EventColors } from 'src/app/models/event-colors';

@Component({
  selector: 'app-document-folder-card',
  templateUrl: './document-folder-card.component.html',
  styleUrls: ['./document-folder-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentFolderCardComponent {
  @Input() folder: IFolder;
  @Input() colors: EventColors;
  @Input() language: string;
  @Input() index: number = 0;
  @Input() viewMode: 'grid' | 'list' = 'grid';

  @Output() folderClick = new EventEmitter<IFolder>();

  get hasCustomImage(): boolean {
    return !!this.folder?.folderCoverImg && this.folder.folderCoverImg.trim() !== '';
  }

  get documentCountLabel(): string {
    const count = this.folder?.documentCount ?? 0;
    if (count === 1) return '1 documento';
    return `${count} documentos`;
  }

  onClick(): void {
    this.folderClick.emit(this.folder);
  }
}
